import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

const ContainerCustom = ({ children, ...attrs }) => {
  return (
    <div
      className={
        classNames(
          attrs.className,
          [
            'px-4 md:px-8',
            'relative',
            'container',
            'py-4'
          ])
      }>
      {children}
    </div>
  )
}

ContainerCustom.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
}

export default React.memo(ContainerCustom)
